import { Modal } from '@mui/material'

import { Button } from '@components/shared/Button'
import { LoadingGrid } from '@components/shared/LoadingGrid'
import { emotionTheme } from '@styles/theme'
import { XIcon } from '@phosphor-icons/react'

import type { BaseModalProps } from './types'

import * as S from './styles'

export const BaseModal2 = ({
  open,
  title,
  headerIcon,
  children,
  width = 400,
  heightContainer,
  maxHeightContainer,
  loading,
  footer,
  onClose,
  disableClose
}: BaseModalProps) => {
  const containerStyles: { maxWidth: string | number; height?: string | number; maxHeight?: string | number } = {
    maxWidth: width
  }

  if (typeof heightContainer !== 'undefined') {
    containerStyles.height = heightContainer
  }

  if (typeof maxHeightContainer !== 'undefined') {
    containerStyles.maxHeight = maxHeightContainer
  }

  return (
    <Modal
      open={open}
      disableEscapeKeyDown={disableClose}
      onClose={(_, reason) => {
        if (disableClose && reason === 'backdropClick') return
        onClose(false)
      }}
    >
      <S.Container>
        <S.Wrapper sx={containerStyles}>
          <S.Header>
            <S.TitleBox>
              {headerIcon}
              {!!title && title}
            </S.TitleBox>

            {!disableClose && (
              <S.CloseIcon onClick={() => onClose(false)}>
                <XIcon size={22} weight="bold" color={emotionTheme.colors.secondary} />
              </S.CloseIcon>
            )}
          </S.Header>

          <S.Content hasFooter={!!footer}>
            {children}

            {!!loading && (
              <S.LoaderBox>
                <LoadingGrid />
              </S.LoaderBox>
            )}
          </S.Content>

          {!!footer && (
            <S.Footer $actionsAlign={footer.actionsAlign}>
              <Button
                width={footer.cancelButtonMinWidth || 120}
                colorType="outlineBlue"
                onClick={() => onClose(false)}
                disabled={footer.loading || loading || footer.cancelButtonDisabled}
              >
                {footer.cancelButtonText}
              </Button>

              {!!footer.confirmButtonText && (
                <Button
                  width={footer.confirmButtonMinWidth || 120}
                  type="submit"
                  colorType="solidBlue"
                  onClick={footer.onConfirm}
                  loading={footer.loading}
                  disabled={loading || footer.loading || footer.confirmButtonDisabled}
                >
                  {footer.confirmButtonText}
                </Button>
              )}
            </S.Footer>
          )}
        </S.Wrapper>
      </S.Container>
    </Modal>
  )
}
